var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fbBtn",attrs:{"loading":_vm.loading},on:{"click":_vm.logInWithFacebook}},[_c('v-icon',[_vm._v("mdi-facebook")]),_vm._v(" Continuer avec Facebook ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }